(() => {
  'use strict';
  const open = () => new Promise((resolve, reject) => {
    const request = indexedDB.open('duvanze-draft-files', 1);
    request.onupgradeneeded = () => request.result.createObjectStore('drafts');
    request.onsuccess = () => resolve(request.result);
    request.onerror = () => reject(new Error('Unable to save your preview. Please allow browser storage and try again.'));
    request.onblocked = () => reject(new Error('Please close other dress customization tabs and try again.'));
  });
  const transact = async (mode, action) => {
    const db = await open();
    return new Promise((resolve, reject) => {
      const transaction = db.transaction('drafts', mode);
      const request = action(transaction.objectStore('drafts'));
      transaction.oncomplete = () => { db.close(); resolve(request.result); };
      transaction.onabort = transaction.onerror = () => {
        db.close();
        reject(new Error('Unable to access your saved preview. Please return to the dress page and try again.'));
      };
    });
  };
  window.DuvanzeDraftFiles = {
    async save(files, productId, variantId) {
      if (!files.length) return null;
      const id = crypto.randomUUID();
      await transact('readwrite', store => {
        const cursor = store.openCursor();
        cursor.onsuccess = () => {
          const entry = cursor.result;
          if (!entry) return;
          if (entry.value.createdAt < Date.now() - 7 * 86400000) entry.delete();
          entry.continue();
        };
        return store.put({ files, productId, variantId, createdAt: Date.now() }, id);
      });
      return id;
    },
    async load(id, productId, variantId) {
      const record = await transact('readonly', store => store.get(id));
      if (!record || record.productId !== productId || record.variantId !== variantId ||
          Date.now() - record.createdAt > 7 * 86400000 ||
          !record.files?.length || record.files.some(entry => !(entry.file instanceof Blob) || !entry.file.size)) {
        throw new Error('Your preview has expired. Please return to the dress page and select your customization again.');
      }
      return record.files;
    }
  };
})();
